/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type AbstractControl, type ValidationErrors } from '@angular/forms';

export class AccessUserValidators {
    /**
     * 规则：只能包含字母、数字、“_”、“-”、“.”和“$”，并且不能以“-”或“$”开头。
     * 具体范围：a-zA-Z0-9_-
     *
     * @static
     * @param {AbstractControl} control 所属控制器
     * @returns {(ValidationErrors|null)} 验证通过，返回null；否则，返回验证错误
     * @memberof ValidatorService
     */
    static accessName(control: AbstractControl): ValidationErrors | null {
        if (!control.value) {
            return null;
        }

        const REGEXP = /^([._A-Za-z0-9][-_.$A-Za-z0-9]*)$/;
        const isValid = REGEXP.test(control.value);
        return isValid ? null : { accessName: true };
    }
}
